import { AppNS } from 'app';
import { FileInfo } from 'app/ui/components/multi-file-uploader/MultiFileUploader';
import axios, { Canceler } from 'axios';

import { API_URL } from '../../core/config';
import { ApiNS } from '../api';
import {
  parseStaffMemberAddData,
  parseStaffMemberEditData,
  parseStaffMembersData,
} from './agency-staff-parsers';

const URL = 'staff-members';
const DOCUMENTS_URL = 'documents';

const CancelToken = axios.CancelToken;
let cancel: Canceler;

export function getStaffMembers(params: AppNS.Params): Promise<any> {
  if (cancel !== undefined) {
    cancel();
  }
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}/${URL}`, {
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        }),
        params,
      })
      .then(({ data }) => {
        if (data.results) {
          resolve(parseStaffMembersData(data.results));
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}

export function apiCreateInspectorProfile(
  reqData: Omit<AppNS.InspectorProfile, 'id'>
): Promise<AppNS.Params> {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}/${URL}.json`, parseStaffMemberAddData(reqData))
      .then(({ data }) => {
        if (data.model) {
          resolve(data.model);
        } else {
          reject(data);
        }
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
}

export function apiUpdateInspectorProfile(
  reqData: AppNS.InspectorProfile
): Promise<AppNS.Params> {
  return new Promise((resolve, reject) => {
    axios
      .patch(
        `${API_URL}/${URL}.json?return_properties=true`,
        parseStaffMemberEditData(reqData)
      )
      .then(({ data }) => {
        if (data.model) {
          resolve(data.model);
        } else {
          reject(data);
        }
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
}

export function deleteInspectorProfile(reqData: AppNS.Params): Promise<string> {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${API_URL}/${URL}.json`, { params: reqData })
      .then(({ data }) => {
        if (data.model) {
          resolve(data.model.id);
        } else {
          reject(data);
        }
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
}

export function apiAddStaffDocument(
  reqData: ApiNS.AddStaffDocumentRequest
): Promise<FileInfo> {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}/${DOCUMENTS_URL}.json?return_properties=true`, reqData)
      .then(({ data }) => {
        if (data.model) {
          // Added timeout because of s3 404 error when private url is invoked immediately
          setTimeout(() => {
            resolve({
              id: data.model.id,
              documentId: data.model.id,
              thumbnail: '',
              url: data.model.file.url,
              uppyId: '',
              name: data.model.properties.file.fileName,
              isLoaded: true,
              isRemoved: false,
            });
          }, 500);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}

export function apiDeleteStaffDocument(id: string): Promise<FileInfo> {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${API_URL}/${DOCUMENTS_URL}.json`, {
        params: { id },
      })
      .then(({ data }) => {
        if (data.model) {
          resolve(data.model.id);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}
